// extracted by mini-css-extract-plugin
export var content = "style-module--content--1f0e7";
export var form = "style-module--form--21aa3";
export var formWrap = "style-module--form-wrap--898f9";
export var reg = "style-module--reg--4facb";